
const { config } = require("process");
import { updateFontSize } from "../helpers/addin-config";

(function() {
  'use strict';

  // The onReady function must be run each time a new page is loaded.
  Office.onReady(function() {     

      let newConfig = {};
      newConfig.fontSize = "s";

      if (window.location.search) {
        const fontSize = getParameterByName('fs');

        if(!fontSize){
          //is default m
        }
        else
        {
          newConfig.fontSize = fontSize;
          updateFontSize("choicefieldgroup", fontSize);
        }
      }


      $('input[name="mw-in-fs"][value="' + newConfig.fontSize + '"]').prop('checked', true);

      $(document).on('msChoicefield', function(event) {
          // event.srcElement is the <label> that was activated
          var $label = $(event.target || event.srcElement);
          // Find the corresponding hidden input (sibling of the label)
          var $input = $label.siblings('input[type=radio]');
          newConfig.fontSize = $input.val();

          updateFontSize("choicefieldgroup", newConfig.fontSize);
          console.log('Selected value:', newConfig.fontSize);

          $('#mw-btn-apply').prop('disabled', newConfig.fontSize == fontSize);

      });

      $('input[name="mw-in-fs"]').on('click', function () {
        newConfig.fontSize = $('input[name="mw-in-fs"]:checked').val();

        $('#mw-btn-apply').prop('disabled', newConfig.fontSize == fontSize);

      });

      // When the Done button is selected, send the
      // values back to the caller as a serialized
      // object.
      $('#mw-btn-apply').on('click', function() {
        if(sessionStorage){
          sessionStorage.setItem("fontSize", newConfig.fontSize);
        }
        
        sendMessage(JSON.stringify(newConfig));
      });

      $('#mw-btn-cancel').on('click', function() {
        sendMessage("close");
      });

  });

  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

    if (!results) return null;

    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
})();